import { usePathname } from "next/navigation";

import {
  sectionHeaderVariant,
  type SectionHeaderVariantProps,
} from "./section-header.variants";

export type UseSectionHeaderProps = SectionHeaderVariantProps & {
  title?: string | null;
  subtitle?: string | null;
  description?: string | null;
  anchor?: string | null;
  appearance?: "primary" | "secondary";
};

export const useSectionHeader = (props: UseSectionHeaderProps) => {
  const { anchor, appearance, ...rest } = props;
  const pathname = usePathname();

  const styles = sectionHeaderVariant({ appearance });

  const link = `${pathname}#${anchor}`;

  return {
    data: { ...rest, link },
    appearance,
    styles,
  };
};
